import axios from 'axios';

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const uploadPhoto = async (date, file, description = '', rating = null) => {
  const formData = new FormData();
  if (file) {
    formData.append('photo', file);
  }
  formData.append('date', date);
  formData.append('description', description);
  if (rating != null) {
    formData.append('rating', rating.toString());
  } else {
    formData.append('rating', '');
  }

  const response = await api.post('/api/photos', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const getPhotos = async () => {
  const response = await api.get('/api/photos');
  console.log(response.data);
  return response.data;
};

export const getPhotoByDate = async (date) => {
  const response = await api.get(`/api/photos/${date}`);
  return response.data;
};

export const getPhotosByMonth = async (year, month) => {
  const response = await api.get(`/api/photos/calendar/${year}/${month}`);
  return response.data;
};

export default api;

